import React from 'react';
import { Helmet } from 'react-helmet';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/fonts.css';
import { hydrate, render } from "react-dom";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <Helmet>
      <meta charSet="utf-8" />
      <title>DJ Fracking</title>
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <link rel="manifest" href="/manifest.json" />

      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content="DJ Fracking's official website: DJ sets, JFK Files Archive, Underground Maps, and research projects." />
      <meta name="keywords" content="DJ Fracking, JFK Files Archive, Underground Maps, research, DJ" />
      <meta property="og:title" content="DJ Fracking" />
      <meta property="og:description" content="DJ sets, JFK Files Archive, Underground Maps, and research projects." />
      <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/djfracking.appspot.com/o/djfracking_logo_wide.png?alt=media&token=72c8f353-f0f9-463c-966e-4f7b644bea5d" />  
  
    </Helmet>
    <App />
  </React.StrictMode>
);

if (typeof globalThis === 'undefined' && typeof window !== 'undefined') {
  window.globalThis = window;
}

if (rootElement.hasChildNodes()) {
  hydrate(app, rootElement);
} else {
  render(app, rootElement);
}

reportWebVitals();
